module.exports = __webpack_public_path__ + "static/media/7 Secret Strategies for Growth, Recognition- Add Cover.4c7f4974.pdf";